import { render } from "./Profile.vue?vue&type=template&id=67782901"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__